import { useLayoutEffect, useRef, type ReactNode } from 'react'

/** Keep the chat within the visible screen when the keyboard or zoom changes it. */
export function ChatViewport({ children }: { children: ReactNode }) {
  const frameRef = useRef<HTMLDivElement>(null)

  useLayoutEffect(() => {
    const frame = frameRef.current
    const viewport = window.visualViewport
    if (!frame || !viewport) return

    const updateViewport = () => {
      Object.assign(frame.style, {
        top: `${viewport.offsetTop}px`, left: `${viewport.offsetLeft}px`,
        width: `${viewport.width}px`, height: `${viewport.height}px`,
      })
    }
    updateViewport()
    viewport.addEventListener('resize', updateViewport)
    viewport.addEventListener('scroll', updateViewport)
    return () => {
      viewport.removeEventListener('resize', updateViewport)
      viewport.removeEventListener('scroll', updateViewport)
    }
  }, [])

  return (
    <div ref={frameRef}
      className="fixed left-0 top-0 z-50 flex h-dvh w-full items-end overflow-clip p-2 pb-[max(0.5rem,env(safe-area-inset-bottom))] sm:p-4 sm:pb-6 pointer-events-none">
      {children}
    </div>
  )
}
